import { render, staticRenderFns } from "./CaracteristicaProfissional.vue?vue&type=template&id=23b2e141"
import script from "./CaracteristicaProfissional.vue?vue&type=script&lang=js"
export * from "./CaracteristicaProfissional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports